<template>
    <div class="box reveal-bottom">
        <div class="img" :style="{ backgroundImage: 'url(' + img + ')' }">
            {{ cityName }}
        </div>
        <div class="adr-box">
            <p class="adr">{{ address }}</p>
            <p class="other" v-html="other"></p>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        img: String,
        cityName: String,
        address: String,
        other: String,
    },
};
</script>
<style scoped>
.box {
    width: 560px;
    height: 458px;
    background: #ffffff;
    box-shadow: 0 43px 105px -20px #eeeeee;
    margin-bottom: 80px;
}
.img {
    height: 270px;
    background-position: center;
    background-size: 560px 270px;
    text-align: center;
    line-height: 270px;
    font-size: 22px;
    color: #ffffff;
    letter-spacing: 0;
    font-weight: bold;
}
.adr-box {
    box-sizing: border-box;
    padding-left: 28px;
}
.adr {
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    line-height: 24px;
    margin-top: 33px;
}
.adr > span {
    font-weight: bold;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    line-height: 32px;
}
.other {
    margin-top: 10px;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    line-height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/Pages/Overview/Card.vue